import {
  usePersonalization,
  useUpdatePersonalization,
} from "@/hooks/useSettings";
import type { InterfaceLayout } from "@/types/settings";

export type { InterfaceLayout } from "@/types/settings";
/** Server-side account preference. Never changes route permissions or business data. */
export function useInterfaceLayout() {
  const { data, isError, refetch } = usePersonalization();
  const update = useUpdatePersonalization();
  return {
    layout: (data?.interfaceLayout === "classic"
      ? "classic"
      : "studio") as InterfaceLayout,
    hasChosen:
      data?.interfaceLayout === "classic" || data?.interfaceLayout === "studio",
    isLoaded: !!data,
    isError,
    refetch,
    isPending: update.isPending,
    setLayout: (layout: InterfaceLayout) =>
      update.mutateAsync({ interfaceLayout: layout }),
  };
}
